var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencilWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.06631 18.8904H4.65818C5.02191 18.8904 5.3638 18.749 5.62065 18.4914L18.4804 5.62251C18.7372 5.36548 18.8792 5.02334 18.8792 4.65936C18.8792 4.29537 18.7372 3.95323 18.4804 3.6962L15.6751 0.888971C15.1609 0.374331 14.2645 0.374331 13.7502 0.888971L0.891052 13.7573C0.637075 14.0103 0.491699 14.3616 0.491699 14.721V18.3154C0.491699 18.6328 0.749124 18.8904 1.06631 18.8904ZM4.65818 17.7423H1.64092V14.7229C1.64092 14.6665 1.66332 14.613 1.70297 14.5728L14.5633 1.7039C14.6707 1.5958 14.7546 1.5958 14.8626 1.7039L17.6679 4.51113C17.7219 4.56518 17.7299 4.62843 17.7299 4.66121C17.7299 4.69399 17.7219 4.75724 17.6679 4.81129L4.80815 17.6802C4.76793 17.7204 4.71507 17.7423 4.65818 17.7423Z",
    fill: "#FCFCFD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5476 6.95899C15.6596 7.07112 15.8067 7.12747 15.9538 7.12747C16.1009 7.12747 16.248 7.07169 16.3601 6.95899C16.5847 6.73416 16.5847 6.37017 16.3601 6.14592L13.2256 3.0092C13.0009 2.78437 12.6378 2.78437 12.4131 3.0092C12.1884 3.23403 12.1884 3.59802 12.4131 3.82227L15.5476 6.95899ZM4.05464 16.3586C4.16727 16.5086 4.33965 16.5879 4.51433 16.5879C4.63442 16.5879 4.75566 16.5506 4.85909 16.473C5.1125 16.2822 5.16364 15.9219 4.97287 15.6685C4.61374 15.1899 4.18853 14.7653 3.70988 14.405C3.4559 14.2154 3.0962 14.2659 2.90543 14.5193C2.71466 14.7727 2.7658 15.133 3.0192 15.3238C3.41166 15.6185 3.75987 15.9668 4.05464 16.3586Z",
    fill: "#FCFCFD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilWhite);
export default __webpack_public_path__ + "static/media/pencil-white.0d7cb99cf494df2687c3df5be706572c.svg";
export { ForwardRef as ReactComponent };